import axios from 'axios';
import { should_use_v2_api } from '@/helpers';

const getDevelopmentBaseUrl = () =>
	should_use_v2_api()
		? `${process.env.VUE_APP_V2_API_BASE_URL}`
		: `http://${process.env.VUE_APP_CORS_HOST}:${process.env.VUE_APP_CORS_PORT}/${process.env.VUE_APP_SIDEARM_INSTANCE_BASE_URL}`;

const baseUrl =
	process.env.NODE_ENV === 'production' ? `/` : getDevelopmentBaseUrl();

export default axios.create({
	baseURL: baseUrl,
	headers:
		should_use_v2_api() && process.env.VUE_APP_V2_API_TENANT
			? { tenant: process.env.VUE_APP_V2_API_TENANT }
			: null,
});
